// client/src/coms/views/canvas_parts/party/partyMeta.js
// Presentation details for the party games (icons only; names, rules and settings come from the server).

export const MODE_ICONS = {
  relay: '🔁',
  pencil: '✏️',
  film: '🎞️',
  mask: '🎭',
  brain: '🧠',
  'eye-off': '🙈',
  bolt: '⚡',
  bomb: '💣',
  copy: '🪞',
  users: '👥',
  halves: '🌓',
  dice: '🎲',
};

export const RESULT_TITLES = {
  completed: 'Game over',
  not_enough_players: 'Game over: not enough players',
  ended_by_host: 'The host ended the game',
};
